// extracted by mini-css-extract-plugin
export default {"rootCentered":"Prompt_rootCentered__tW8I7"};